module.exports = __webpack_public_path__ + "img/wellve_1.68ef2d9d.jpg";